import request from '@/utils/request';
import * as types from '@/api/merge/types';
import { reqCatch, reqCatchV2 } from '@/utils/catch';
import { ISSUE_PR_API_PREFIX } from '@/constant/index';

const removeParamsPathId = (data: types.commonMergeReqType): types.commonMergeReqType => {
  delete data.project_id;
  delete data.merge_request_iid;
  delete data.discussion_id;
  delete data.note_id;
  delete data.group_id;
  delete data.note_id;
  return data;
};

const urlPre = '/api/v1/projects/';
/**
 * 发送 HTTP GET 请求
 *
 * @param url 请求的 URL
 * @param params 请求参数
 * @param issuePrTransfer 是否是 issue 或 pr 相关的请求
 * @param customError 是否自定义错误处理
 * @returns 返回 Promise 对象，包含请求返回的结果
 */
const httpGet = (url: string, params: types.commonMergeReqType, issuePrTransfer?: boolean, customError: boolean = false, timeout?: number, signal?: AbortSignal): Promise<types.commonMergeResType> => request({
  url: issuePrTransfer ? `${ISSUE_PR_API_PREFIX}${urlPre}${url}` : `${urlPre}${url}`,
  method: 'get',
  params,
  issuePrTransfer,
  signal
}, {
  customError,
  customTimeout: timeout
});
const httpPost = (url: string, data: types.commonMergeReqType, issuePrTransfer?: boolean): Promise<types.commonMergeResType> =>
  request({
    url: issuePrTransfer ? `${ISSUE_PR_API_PREFIX}${urlPre}${url}` : `${urlPre}${url}`,
    method: 'post',
    data
  });
const httpPut = (url: string, data: types.commonMergeReqType, issuePrTransfer?: boolean): Promise<types.commonMergeResType> =>
  request({
    url: issuePrTransfer ? `${ISSUE_PR_API_PREFIX}${urlPre}${url}` : `${urlPre}${url}`,
    method: 'put',
    data
  });
const httpDel = (url: string, data: types.commonMergeReqType, issuePrTransfer?: boolean): Promise<types.commonMergeResType> =>
  request({
    url: issuePrTransfer ? `${ISSUE_PR_API_PREFIX}${urlPre}${url}` : `${urlPre}${url}`,
    method: 'delete',
    data
  });

// 创建合并请求
export const createMerge = data => httpPost(`${data.repoId}/merge_requests`, data, true);
// 修改合并请求
export const putMerge = data => httpPut(`${data.repoId}/isource/merge_requests/${data.iid}`, data, true);
// 修改审核人
// NOTE: ISSUE_PR_API_PREFIX 未调用
export const putApprovers = data => httpPut(`${data.repoId}/merge_requests/${data.iid}/approval_approvers`, data, true);
// 修改检视人
export const putReviewers = data => httpPut(`${data.repoId}/merge_requests/${data.iid}/approval_reviewers`, data, true);
// 详情已分配合并人列表
export const assignees = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/assignees`, data, true);
// 详情分配合并人（筛选项）
export const assigneeCandidates = data => httpGet(`${data.repoId}/merge_requests/assignee_candidates`, data, true);
// 详情获取已分配检视人
export const approvalReviewers = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/approval_reviewers`, data, true);
export const updateApprovalReviewers = data => httpPut(`${data.repoId}/merge_requests/${data.iid}/approval_reviewers`, data, true);
// 详情获取已分配检视人（筛选项）
export const approvalReviewersOption = params => httpGet(`${params.repoId}/merge_requests/approval_reviewers`, params, true);
// 详情获取已关联issue
export const fetchPRIssueList = params => httpGet(`${params.project_id}/merge_requests/${params.merge_request_iid}/e2e_issues`, params, true);
export const updateIssueList = params => httpPut(`${params.project_id}/isource/merge_requests/${params.merge_request_iid}`, params, true);
// 列表页 获取审视人(不关联mr)
export const fetchApprovalReviewers = params => httpGet(`${params.repoId}/merge_requests/reviewers`, params, true);
// 列表页 获取审视人(不关联mr)

// 获取pr模板
export const fetchPrTemplate = (params:{ project_id: string, language: string }) => request({
  url: `/api/v2/projects/${params.project_id}/repository/template/pr`,
  method: 'get',
  params: {
    language: params.language
  }
});

// 获取 pr 参与者
export const fetchPrParticipants = (params:{ project_id: string, merge_request_iid: number }) => request({
  url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${params.project_id}/merge_requests/${params.merge_request_iid}/participants`,
  method: 'get'
});

// 获取pr 门禁默认设置人员
export const fetchPrSetDefaultPerson = (params: types.commonMergeReqType) => httpGet(`${params.repoId}/create_merge_requests/person_liable`, params, true);
// 创建时搜索门禁人员列表
export const searchPrSetPerson = (params: types.commonMergeReqType) => httpGet(`${params.repoId}/merge_requests_create/search_person_liable`, params, true);

// 获取已经设置门禁人员列表 汇总 评审人，审查人，测试人
export const fetchPrExaminePerson = (params: types.commonMergeReqType) => httpGet(`${params.repoId}/merge_requests/${params.iid}/person_liable`, params, true);
// 搜索 门禁设置人员
export const searchPrExaminePerson = (params: { merge_request_iid: number|string; source_branch: string; target_branch: string;
  search_type: string; target_project_id: string; project_id:string, approval_type: string; search: string; page: number; per_page: number;
}) => httpGet(`${params.project_id}/merge_requests/${params.merge_request_iid}/search_person_liable`, params, true);

// 获取门禁配置 汇总版 评审人，审查人，测试人
export const fetchPrExamineRules = (params: types.commonMergeReqType) => httpGet(`${params.repoId}/merge_requests/${params.iid}/person_liable_rules`, params, true);
//   指定配置各个门禁人员配置
export const editPrExaminePerson = (data: types.commonMergeReqType) => request({
  url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${data.repoId}/merge_requests/${data.iid}/person_liable`,
  method: 'put',
  data
});

// 审查门禁
export const examineApproval = (data:types.examineApprovalType) => request({
  url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${data.repoId}/merge_requests/${data.iid}/approval`,
  method: 'put',
  data
});

// 测试门禁
export const examineTester = (data:types.examineTesterType) => request({
  url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${data.repoId}/merge_requests/${data.iid}/approval_test`,
  method: 'put',
  data
});

// 合并
export const merge = data => httpPut(`${data.repoId}/merge_requests/${data.iid}/merge`, data, true);
// 关闭
export const closeMerge = data => httpPut(`${data.repoId}/isource/merge_requests/${data.iid}`, data, true);
// 仓库MR创建者列表
// NOTE: ISSUE_PR_API_PREFIX 未调用
export const users = data => httpGet(`${data.repoId}/merge_requests/users`, data, true);

// pr列表相关用户
export const fetchPrUsers = (params: types.PrUserParams) => reqCatch(() => request({
  url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${params.project_id}/merge_requests/users`,
  method: 'get',
  params
}));

// 项目MR列表
export const getMergeRequests = data => {
  const { signal, ...otherData } = data;
  return httpGet(`${otherData.repoId}/isource/merge_requests`, otherData, true, false, undefined, signal);
};
export const getMergeListCount = data => httpGet(`${data.repoId}/isource/merge_requests/count`, data, true);
// 我的MR 列表
export const getMyMergeRequests = (params: object) => request({ url: `${ISSUE_PR_API_PREFIX}/api/v1/merge_requests`, method: 'get', params });
// 组织 mr 列表
export const getMyOrgMergeRequests = (params: object) => request({ url: `${ISSUE_PR_API_PREFIX}/api/v1/groups/${params.group_id}/merge_requests`, method: 'get', params });
// 合并请求详情 @param view:[simple,basic]
export const mergeDetail = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/internal`, data, true, true);
// 讨论列表
export const mrDiscussions = data => httpGet(`${data.project_id}/merge_requests/${data.merge_request_iid}/discussions`, removeParamsPathId(data), true, true, 120 * 1000);
// 获取评论详情
export const getMrNote = data => httpGet(`${data.project_id}/merge_requests/${data.merge_request_iid}/notes/${data.note_id}`, removeParamsPathId(data), true);

// 创建评论	- 代码评论 - 有解决状态
export const addMRDiscussion = data => httpPost(`${data.project_id}/merge_requests/${data.merge_request_iid}/discussions`, removeParamsPathId(data), true);
// 更新 评论
export const updateMRDiscussion = data => httpPut(`${data.project_id}/merge_requests/${data.merge_request_iid}/discussions/${data.discussion_id}`, data, true);
// 创建评论 没有 解决状态
export const addMRDiscussionNote = data => httpPost(`${data.project_id}/merge_requests/${data.merge_request_iid}/notes`, removeParamsPathId(data), true);
// 修改评论
export const putDiscussionsNotes = data => httpPut(`${data.project_id}/merge_requests/${data.merge_request_iid}/notes/${data.note_id}`, data, true);
// 创建回复评论
export const replayDiscussionsNote = data => httpPost(`${data.project_id}/merge_requests/${data.merge_request_iid}/discussions/${data.discussion_id}/notes`, data, true);
// export const updateReplayDiscussionsNote = data => httpPut(`${data.project_id}/merge_requests/${data.merge_request_iid}/discussions/${data.discussion_id}/notes/${data.note_id}`, data);

// 删除 mr 评论
export const delMRDiscussionsNote = (data) => request({
  url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${data.project_id}/merge_requests/${data.merge_request_iid}/notes/${data.note_id}`,
  method: 'delete'
});
// 代码评论	- 没有解决状态
// 文件提交记录	commit 记录 - 查库
export const commits = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/commits`, data, true);
// 检查列表 (合并门禁)
export const mergeableState = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/mergeable_state`, data, true);
// 文件差异	查库
export const mrChanges = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/changes`, data, true);
// 文件差异目录
export const mrChangesTrees = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/changes_trees`, data, true);
// revert
export const revert = data => httpPost(`${data.repoId}/merge_request/${data.iid}/revert`, data, true);
// cherry-pick
export const cherryPick = data => httpPost(`${data.repoId}/merge_request/${data.iid}/cherry_pick`, data, true);

export const versions = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/versions`, data, true);
// 获取评审人数
export const getReviewers = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/reviewer_rules`, data, true);
// discussions
export const getDis = data => httpGet(`${data.repoId}/merge_requests/${data.iid}/comments_by_line`, data, true);
export const postDis = data => httpPost(`${data.repoId}/merge_requests/${data.iid}/discussions`, data, true);
export const postNote = data => httpPost(`${data.repoId}/merge_requests/${data.iid}/discussions/${data.disId}/notes`, data, true);
export const putNote = data => httpPut(`${data.repoId}/merge_requests/${data.iid}/notes/${data.noteId}`, data, true);
export const delNote = data => httpDel(`${data.repoId}/merge_requests/${data.iid}/notes/${data.noteId}`, data, true);
export const diffLines = data => httpGet(`${data.repoId}/repository/diff_lines`, data, true);

// 检视意见统计信息与门禁信息
export const statistic = data => httpGet(`${data.repoId}/merge_requests/statistic`, data, true);
export const conflict_files = data => httpGet(`${data.repoId}/merge_requests/conflict_files`, data, true);
export const convertMrComment = data => httpPut(`${data.repoId}/merge_requests/${data.iid}/approval_reviewers`, data, true);
// 变基rebase
export const changeMrRebase = data => httpPut(`${data.repoId}/merge_requests/${data.iid}/rebase`, data, true);
// 重新打开
export const reOpen = data => httpPut(`${data.repoId}/isource/merge_requests/${data.iid}`, data, true);
// MR详情审核人审核通过/拒绝/撤销按钮
export const putApproval_review = data => request({
  url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${data.repoId}/merge_requests/${data.iid}/approval_review`,
  method: 'put',
  data
});
// 最新一次流水线 show_job =true
export const diverged_commits_count = (repoId, iid) => httpGet(`${repoId}/merge_requests/${iid}/diverged_commits_count`, {}, true);

export const litePrSubmit = (data: types.ILitePrParams):Promise<types.commonMergeResType> => request({
  url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${data.project_id}/lite_merge_requests`,
  method: 'post',
  data
}, { customTimeout: 60 * 1000 * 10 });

// 获取冲突文件
export const getConflictFiles = (data, params) => httpGet(`${data.project_id}/merge_requests/${data.merge_request_id}/conflict_files`, params, true);
export const resolveConflicts = (data, params) => httpPut(`${params.project_id}/merge_requests/${params.merge_request_id}/resolve_conflicts`, data, true);

// 根据commitId 获取注释列表
export const getCommitAnnotations = (data, params) => request({
  url: `/api/v2/projects/pipeline-check/${data.project_id}/commit/${data.commit_id}/annotations`,
  method: 'get',
  params
});

// 根据commitId prId 获取注释列表
export const getMrCommitAnnotations = (data, params) => request({
  url: `/api/v2/projects/pipeline-check/${data.project_id}/merge_requests/${data.merge_request_iid}/commit/${data.commit_id}/annotations`,
  method: 'get',
  params
});

// 获取合并请求的注释列表
export const getMrAnnotations = (data, params) => request({
  url: `/api/v2/projects/pipeline-check/${data.project_id}/merge_requests/${data.merge_request_iid}/annotations`,
  method: 'get',
  params
});

// 新版流水线结果获取
export function getPipelineConfig(param: { projectId: string, mrId:string }) {
  return request({
    url: `/api/v2/projects/pipeline-check/${param.projectId}/merge_requests/${param.mrId}/actual_head_pipeline`,
    method: 'get',
    params: {
      show_job: true
    }
  });
}

// 获取流水线运行状态(综合)
export function getPipelineInfoPolling(param: { projectId: string, mrId: number; type?: string }) {
  return request({
    url: `/api/v2/projects/pipeline-check/${param.projectId}/merge_requests/${param.mrId}/pipeline_info_polling`,
    method: 'get',
    params: param.type ? { type: param.type } : undefined
  });
};
// /api/v2/projects/pipeline-check/{project_id}/merge_requests/{merge_request_iid}/pipeline_info_polling

// 获取流水线日志详情
export function getPipelineJobLogs(param: { projectId: string, jobId: string }) {
  return request({
    url: `/api/v2/projects/pipeline-check/${param.projectId}/job/${param.jobId}/report`,
    method: 'get'
  });
}

// 分页查询 pr 流水线日志 - 新接口
export function getPipelineJobLogsNew(data: {
  projectId: string;
  pipeline_detail: string;
  start_offset: number | string;
  end_offset: number | string;
  limit: number;
  sort: string;
}) {
  const { projectId, ...rest } = data;
  return reqCatch(
    () =>
      request({
        url: `api/v2/projects/pipeline-check/${projectId}/pipeline/detail/logs`,
        method: 'post',
        data: rest
      }),
    data
  );
}

// 获取流水线失败得注释列表，分页
export function getPipelineAnnotations(param: {
  projectId: string,
  mrId: string,
  level?: string,
  page: number,
  pageSize?: number
}) {
  return request({
    url: `/api/v2/projects/pipeline-check/${param.projectId}/merge_requests/${param.mrId}/annotations`,
    method: 'get',
    params: {
      annotation_level: param.level,
      page: param.page,
      per_page: param.pageSize || 20
    }
  });
}

// 获取合并请求的注释列表总数
export function getMrAnnotationsCount(data: {projectId: string, mrId: string}) {
  return request({
    url: `/api/v2/projects/pipeline-check/${data.projectId}/merge_requests/${data.mrId}/annotations/count`,
    method: 'get'
  });
}

// 解析分支名称，文件 path
export function resolveBranchAndPath(params) {
  return request({
    url: `/api/v2/projects/resolve_path`,
    method: 'get',
    params
  });
};
export function applySuggestions(data: {
  projectId: string,
  mrId: string,
  noteId: string,
  content: string,
  commitMessage: string;
  author_email: string;
  is_signoff: boolean;
  signoff_message?: string;
}) {
  const { projectId, mrId, noteId, commitMessage, ...rest } = data;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${projectId}/merge_requests/${mrId}/notes/${noteId}/apply_suggestions`,
    method: 'post',
    data: {
      commit_message: commitMessage,
      ...rest
    }
  });
}
// 批量提交代码建议
export function applySuggestionsBatch(data: {
  projectId: string,
  mrId: string,
  code_suggestions: any,
  commitMessage: string;
  author_email: string;
  is_signoff: boolean;
  signoff_message?: string;
}) {
  const { projectId, mrId, commitMessage, ...rest } = data;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${projectId}/merge_requests/${mrId}/apply_multi_suggestions`,
    method: 'post',
    data: {
      commit_message: commitMessage,
      ...rest
    }
  });
}

// 获取项目是否隐藏文件改动
export const getNeedVerifyAuditStatus = (params: {projectId: string}) => request({
  url: `/api/v2/projects/${params.projectId}/needVerifyAuditStatus`,
  method: 'get',
  params
});

// 获取分支之间是否有冲突
export const mergeConflict = (params: { target_project_id: string, customTimeout?: number; }) => {
  const { target_project_id, customTimeout, ...rest } = params;
  return request({
    url: `/issuepr/api/v1/projects/${target_project_id}/merge_requests/conflict`,
    method: 'get',
    params: {
      target_project_id,
      ...rest
    }
  }, {
    customTimeout: customTimeout || 30000,
    customError: true,
    ignoreError: true
  });
};

export const cherryPickPrCommits = (data: { project_id: string; iid: string, ff_mode: boolean, commits: { commit_id: string; commit_message?: string; }[], target_branch: string, target_project: string, forked_project: string}) => {
  return reqCatchV2(() => request({
    url: `/issuepr/api/v1/projects/${data.project_id}/merge_request/${data.iid}/fork_cherry_pick`,
    method: 'post',
    data
  }, {
    customTimeout: 60000
  }));
};

// 获取 pr 检视意见列表
export const getCrCommentList = (params: { project_id: string, merge_request_iid?: number; page: number; per_page: number; note_type?: string; unresolved?: boolean; sort?: string }) => {
  const { project_id, merge_request_iid, ...rest } = params;
  return reqCatch(() => request({
    url: `/issuepr/api/v1/projects/${project_id}/merge_requests/${merge_request_iid}/discussions/note_type`,
    method: 'get',
    params: {
      ...rest
    }
  }));
};

// 获取 pr 检视意见队列 - 用于上一条/下一条点击跳转 - 用于 pr/diffs 场景
export const getCrCommentQueue = (params: { project_id: string, merge_request_iid?: number; page: number; per_page: number; }) => {
  const { project_id, merge_request_iid, ...rest } = params;
  return reqCatch(() => request({
    url: `/issuepr/api/v1/projects/${project_id}/merge_requests/${merge_request_iid}/diff_discussions`,
    method: 'get',
    params: {
      ...rest
    }
  }));
};

export function updateTargetBranch(data: {
  projectId: string,
  target_branch: string,
  merge_request_iid: string
}) {
  return request({
    url: `/issuepr/api/v1/projects/${data.projectId}/isource/merge_requests/${data.merge_request_iid}/update_target_branch`,
    method: 'put',
    data: {
      target_branch: data.target_branch
    }
  });
}

export const versionsWithPage = (params: { project_id: string, merge_request_iid?: number; page: number; per_page: number }) => {
  const { project_id, merge_request_iid, ...rest } = params;
  return reqCatch(() => request({
    url: `/issuepr/api/v1/projects/${project_id}/merge_requests/${merge_request_iid}/versions/page`,
    method: 'get',
    params: {
      ...rest
    }
  }));
};

// 获取所有已读未读文件列表 一次只能查100条 查到没有数据为止

export const getReadState = (params: { project_id: string, merge_request_iid: number, page: number; per_page: number }) => {
  return request({
    url: `/issuepr/api/v1/projects/${params.project_id}/merge_requests/${params.merge_request_iid}/diff_review_record_list`,
    method: 'get',
    params: {
      page: params.page,
      per_page: params.per_page
    }
  });
};

// 更新已读未读状态
export const updateReadState = (params: { project_id: string, merge_request_iid: number, diff_review_record: { file_path: string, is_read: boolean } }) => {
  return request({
    url: `/issuepr/api/v1/projects/${params.project_id}/merge_requests/${params.merge_request_iid}/diff_review_record`,
    method: 'put',
    data: params.diff_review_record
  });
};

// 重试流水线
export const retryPipeline = (params: { project_id: string, merge_request_iid: string, pipeline_id: string }) => {
  return request({
    url: `/api/v2/projects/pipeline-check/${params.project_id}/merge_requests/${params.merge_request_iid}/pipelines/${params.pipeline_id}/start`,
    method: 'post',
    data: {
      'rebuild_failed': true
    }
  });
};
